import { AreaPage } from '@kanos/web-core';
import { createFileRoute } from '@tanstack/react-router';
import { DutyDocumentsCard } from '../firm/duty-documents-card';
import { DutyTabs } from '../firm/duty-tabs';

export const Route = createFileRoute('/obligations/documents')({
  component: Documents,
});

/** The firm's risk analysis and internal safeguards (ADR-083 § 5). */
function Documents() {
  return (
    <AreaPage title="Pflichten">
      <DutyTabs current="documents" />
      <DutyDocumentsCard />
    </AreaPage>
  );
}
